import Vue from 'vue'
import { debounce, range } from 'lodash'

const billInfo = {
  state: {
    billInfo: [],
    billDetails: [],
    searchCount: 0,
    loadCount: 0,
    statuses: [],
    selectedBill: {},
    year: {
      // year: 2022,
      // title: 'Budget Session',
      // isActive: !0,
      // sessionStartDate: '20220214',
      // sessionEndDate: '20220312',
      // hasSessionLandingPage: !1,
    },
    // years: [
    //   {
    //     year: 2022,
    //     title: 'Budget Session',
    //     isActive: !0,
    //     sessionStartDate: '20220214',
    //     sessionEndDate: '20220312',
    //     hasSessionLandingPage: !1,
    //   },
    //   {
    //     year: 2021,
    //     title: 'Special Session',
    //     isActive: !0,
    //     sessionStartDate: '20211025',
    //     sessionEndDate: '20211030',
    //     specialSessionValue: 1,
    //     hasSessionLandingPage: !0,
    //   },
    //   {
    //     year: 2001,
    //     title: 'General Session',
    //     isActive: !0,
    //     sessionStartDate: '20010109',
    //     sessionEndDate: '20010301',
    //     hasSessionLandingPage: !1,
    //   },
    //   {
    //     year: 2002,
    //     title: 'Budget Session',
    //     isActive: !0,
    //     sessionStartDate: '20020211',
    //     sessionEndDate: '20020313',
    //     hasSessionLandingPage: !1,
    //   },
    //   {
    //     year: 2003,
    //     title: 'General Session',
    //     isActive: !0,
    //     sessionStartDate: '20030114',
    //     sessionEndDate: '20030306',
    //     hasSessionLandingPage: !1,
    //   },
    //   {
    //     year: 2004,
    //     title: 'Budget Session',
    //     isActive: !0,
    //     sessionStartDate: '20040209',
    //     sessionEndDate: '20040305',
    //     hasSessionLandingPage: !1,
    //   },
    //   {
    //     year: 2005,
    //     title: 'General Session',
    //     isActive: !0,
    //     sessionStartDate: '20050111',
    //     sessionEndDate: '20050303',
    //     hasSessionLandingPage: !1,
    //   },
    //   {
    //     year: 2006,
    //     title: 'Budget Session',
    //     isActive: !0,
    //     sessionStartDate: '20060213',
    //     sessionEndDate: '20060311',
    //     hasSessionLandingPage: !1,
    //   },
    //   {
    //     year: 2007,
    //     title: 'General Session',
    //     isActive: !0,
    //     sessionStartDate: '20070109',
    //     sessionEndDate: '20070301',
    //     hasSessionLandingPage: !1,
    //   },
    //   {
    //     year: 2008,
    //     title: 'Budget Session',
    //     isActive: !0,
    //     sessionStartDate: '20080211',
    //     sessionEndDate: '20080307',
    //     hasSessionLandingPage: !1,
    //   },
    //   {
    //     year: 2009,
    //     title: 'General Session',
    //     isActive: !0,
    //     sessionStartDate: '20090113',
    //     sessionEndDate: '20090305',
    //     hasSessionLandingPage: !1,
    //   },
    //   {
    //     year: 2010,
    //     title: 'Budget Session',
    //     isActive: !0,
    //     sessionStartDate: '20100208',
    //     sessionEndDate: '20100305',
    //     hasSessionLandingPage: !1,
    //   },
    //   {
    //     year: 2011,
    //     title: 'General Session',
    //     isActive: !0,
    //     sessionStartDate: '20110111',
    //     sessionEndDate: '20110303',
    //     hasSessionLandingPage: !1,
    //   },
    //   {
    //     year: 2012,
    //     title: 'Budget Session',
    //     isActive: !0,
    //     sessionStartDate: '20120213',
    //     sessionEndDate: '20120308',
    //     hasSessionLandingPage: !1,
    //   },
    //   {
    //     year: 2013,
    //     title: 'General Session',
    //     isActive: !0,
    //     sessionStartDate: '20130108',
    //     sessionEndDate: '20130227',
    //     hasSessionLandingPage: !1,
    //   },
    //   {
    //     year: 2014,
    //     title: 'Budget Session',
    //     isActive: !0,
    //     sessionStartDate: '20140210',
    //     sessionEndDate: '20140306',
    //     hasSessionLandingPage: !1,
    //   },
    //   {
    //     year: 2015,
    //     title: 'General Session',
    //     isActive: !0,
    //     sessionStartDate: '20150101',
    //     sessionEndDate: '20150310',
    //     hasSessionLandingPage: !1,
    //   },
    //   {
    //     year: 2016,
    //     title: 'Budget Session',
    //     isActive: !0,
    //     sessionStartDate: '20160201',
    //     sessionEndDate: '20160310',
    //     hasSessionLandingPage: !1,
    //   },
    //   {
    //     year: 2017,
    //     title: 'General Session',
    //     isActive: !0,
    //     sessionStartDate: '20170101',
    //     sessionEndDate: '20170310',
    //     hasSessionLandingPage: !1,
    //   },
    //   {
    //     year: 2018,
    //     title: 'Budget Session',
    //     isActive: !0,
    //     sessionStartDate: '20180201',
    //     sessionEndDate: '20180401',
    //     hasSessionLandingPage: !1,
    //   },
    //   {
    //     year: 2019,
    //     title: 'General Session',
    //     isActive: !0,
    //     sessionStartDate: '20190107',
    //     sessionEndDate: '20190310',
    //     hasSessionLandingPage: !1,
    //   },
    //   {
    //     year: 2020,
    //     title: 'Budget Session',
    //     isActive: !0,
    //     sessionStartDate: '20200201',
    //     sessionEndDate: '20200313',
    //     hasSessionLandingPage: !1,
    //   },
    //   {
    //     year: 2020,
    //     title: 'Special Session',
    //     isActive: !0,
    //     sessionStartDate: '20200506',
    //     sessionEndDate: '20200520',
    //     specialSessionValue: 1,
    //     hasSessionLandingPage: !0,
    //   },
    //   {
    //     year: 2021,
    //     title: 'General Session',
    //     isActive: !0,
    //     sessionStartDate: '20210101',
    //     sessionEndDate: '20210401',
    //     hasSessionLandingPage: !1,
    //   },
    // ],
  },

  getters: {
    billInfo (state) {
      return state.billInfo
    },
    selectedBill (state) {
      return state.selectedBill
    },
    billDetails (state) {
      return state.billDetails
    },
    loading (state) {
      return state.searchCount > 0
    },
    itemLoading (state) {
      return state.loadCount > 0
    },
    billType (state) {
      return [...new Set(state.billInfo.map((bill) => bill.billType))]
    },
  },

  mutations: {
    billInfo (state, payload) {
      state.billInfo = payload
    },
    selectedBill (state, payload) {
      state.selectedBill = JSON.parse(JSON.stringify(payload))
      if (state.selectedBill && state.selectedBill.billActions) {
        state.selectedBill.billActions.forEach((item) => {
          var status = item.statusMessage.replace(/[0-9]/g, '#').toLowerCase()
          if (!state.statuses.includes(status)) {
            state.statuses.push(status)
          }
        })
        // console.log(state.statuses)
      }
    },
    updateBillDetails (state, payload) {
      let match = state.billDetails.find(
        (x) =>
          x.bill == payload.bill &&
          x.year == payload.year &&
          x.specialSessionValue == payload.specialSessionValue
      )
      if (match) {
        match = payload
      } else {
        state.billDetails.push(payload)
      }
    },
    searchCount (state, payload) {
      state.searchCount = payload
    },
    increaseSearchCount (state, payload) {
      state.searchCount = state.searchCount + 1
    },
    decreaseSearchCount (state, payload) {
      state.searchCount = state.searchCount - 1
    },
    loadCount (state, payload) {
      state.loadCount = payload
    },
    increaseItemLoadCount (state, payload) {
      state.loadCount = state.loadCount + 1
    },
    decreaseItemLoadCount (state, payload) {
      state.loadCount = state.loadCount - 1
    },
    year (state, payload) {
      state.year = payload
    },
    saving (state, payload) {
      state.saving = payload
    },
  },

  actions: {
    bounce: _.debounce((context) => {
      context.dispatch('loadBill')
    }, 750),
    setYear (context, payload) {
      if (payload != context.state.year) {
        context.commit('year', payload)
        context.dispatch('trackedBill/setSearchYear', payload.Year, {
          root: true,
        })
        context.dispatch(
          'trackedBill/setSearchSpecialSession',
          payload.SpecialSessionValue ? payload.SpecialSessionValue : null,
          { root: true }
        )
        context.dispatch('bounce', context)
        // context.dispatch('trackedBill/', {}, { root: true })
        // context.dispatch(
        //   'trackedBill/loadSharedTrackedBills',
        //   {},
        //   { root: true }
        // )
      }
    },
    setSelectedBill (context, payload) {
      context.commit('selectedBill', payload)
    },
    loadBill (context, payload) {
      if (context?.state?.year?.Year) {
        return new Promise((resolve, reject) => {
          var spSess = !!context.state.year.SpecialSessionValue ? 'ne' : 'eq'
          var selectedFields =
            'BillNum,ShortTitle,Year,ChapterNo,Sponsor,EnrolledNo,LastActionDate,LastAction,SignedDate,EffectiveDate,BillType,SpecialSessionValue,BillStatus'
          var url = `https://web.wyoleg.gov/LsoService/api/BillInformation?$select=${selectedFields}&$filter=Year eq ${context.state.year.Year}and SpecialSessionValue ${spSess}  null`

          context.commit('increaseSearchCount')
          Vue.prototype.$axios.get(url).then(
            (res) => {
              var list = res.data.sort((a, b) => {
                if (a.billNum < b.billNum) {
                  return -1
                }
                if (a.billNum > b.billNum) {
                  return 1
                }
                return 0
              })
              context.commit('billInfo', list)
              context.commit('decreaseSearchCount')
              resolve(res)
            },
            (err) => {
              console.error(err)
              context.commit('decreaseSearchCount')
              context.dispatch('errors/handleError', err, { root: true })
              reject(err)
            }
          )
        })
      }
    },
    refreshSelectedBill (context, payload) {
      if (context.state.selectedBill && context.state.selectedBill.ID > 0) {
        context.dispatch('loadSelectedBill', context.state.selectedBill.ID)
      }
    },
    loadSelectedBill (context, payload) {
      context.commit('selectedBill', {})
      return new Promise((resolve, reject) => {
        context.commit('increaseItemLoadCount')
        context.dispatch('getSelectedBill', payload).then(
          (res) => {
            context.commit('selectedBill', res.data)
            context.commit('decreaseItemLoadCount')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('decreaseItemLoadCount')
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    getSelectedBill (context, payload) {
      return new Promise((resolve, reject) => {
        const url = `https://web.wyoleg.gov/LsoService/api/BillInformation/${payload.year}/${payload.billNum}?specialSessionValue=${payload.specialSessionValue}`
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('updateBillDetails', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            reject(err)
          }
        )
      })
    },
  },
}

export default billInfo
